// TODO: REMOVE?
export const POTENTIAL = 'potential'
export const MATURITY = 'maturity'
export const COMPETENCES = 'competences'

export const CATEGORIES = [POTENTIAL, MATURITY, COMPETENCES]
